import { Chip, Typography } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { emphasize, styled } from '@mui/material/styles';
import { useStoreState } from 'pullstate';
import { AppStore } from '../../stores/AppStore.js';
import HomeIcon from '@mui/icons-material/Home';

export default function BreadcrumbsPeopleBuilder(props) {
    const { breadcrumbsPb, setBreadcrumbsPb, setCurrentUser, setPlayerNameToFilter, openFilter, setOpenFilter } = props;
    const { employees } = useStoreState(AppStore);

    const StyledBreadcrumb = styled(Chip)(({ theme }) => {
        return {
            backgroundColor: theme.palette.grey[100],
            height: theme.spacing(3),
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: theme.typography.fontWeightRegular,
            '&:hover, &:focus': {
                backgroundColor: emphasize(theme.palette.grey[100], 0.06),
                ...theme.applyStyles('dark', {
                    backgroundColor: emphasize(theme.palette.grey[800], 0.06),
                }),
            },
            '&:active': {
                boxShadow: theme.shadows[1],
                backgroundColor: emphasize(theme.palette.grey[100], 0.12),
                ...theme.applyStyles('dark', {
                    backgroundColor: emphasize(theme.palette.grey[800], 0.12),
                }),
            },
            ...theme.applyStyles('dark', {
                backgroundColor: theme.palette.grey[800],
            }),
        };
    });

    const StyledBreadcrumbFirst = styled(Chip)(({ theme }) => {
        return {
            backgroundColor: theme.palette.grey[600],
            height: theme.spacing(3),
            color: theme.palette.grey[50],
            fontWeight: theme.typography.fontWeightRegular,
            pointerEvents: 'none',
        };
    });

    const handleClick = (event, index) => {
        event.preventDefault();

        if (index >= 1) {
            const breadcrumbText = breadcrumbsPb[index];
            const userSelected = employees.find(employee => employee.full_name === breadcrumbText);
            breadcrumbsPb.splice(index + 1);
            setBreadcrumbsPb([...breadcrumbsPb]);
            setCurrentUser(userSelected);
            setPlayerNameToFilter('');
        }
    }

    return (
        <Breadcrumbs aria-label="breadcrumb">
            {breadcrumbsPb.map((breadcrumb, index) => (
                index > 0 ? (
                    <StyledBreadcrumb
                        component="span"
						key={index}
                        href="#"
                        label={
                            <Link
                                key={index}
                                underline='hover'
                                color="inherit"
                                sx={{ cursor: 'pointer' }}
                                onClick={(event) => {
                                    handleClick(event, index);
                                }}
                            >
                                {openFilter ? `${breadcrumb.split(' ')[0]}'s team` : `${breadcrumb.split(' ')[0]}'s players`}
                            </Link>}
                    ></StyledBreadcrumb>
                ) : (
                    <StyledBreadcrumbFirst
                        component="span"
						key={index}
                        sx={index}
                        label={
                            <Link
                                key={index}
                                underline='none'
                                color="inherit"
                            >
                                {breadcrumb === 'President' ? 'ETRO Construction' : `${breadcrumb} department`}
                            </Link>}
                        icon={index === 0 && <HomeIcon fontSize="small" color='inherit' />}
                    >
                    </StyledBreadcrumbFirst>
                )
            ))}
        </Breadcrumbs>
    );
}
